import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../styles/fontStyles';
import {TooltipContentWrapper} from '../tooltipContentWrapper';

/*
 * Props.
 */

interface SimpleTooltipProps {
  children: ReactNode;
}

/*
 * Contants.
 */

const wrapperBorderRadius = '8px';

/*
 * Style.
 */

const StyledDiv = styled.div`
  padding: 6px 8px;
  max-width: 240px;
  font-size: ${fontSizes.verySmall};
  line-height: 1.5;
  font-weight: ${fontWeights.medium};
  word-break: break-word;
`;

/*
 * Component.
 */

export const SimpleTooltip: FC<SimpleTooltipProps> = ({children}) => (
  <TooltipContentWrapper borderRadius={wrapperBorderRadius}>
    <StyledDiv>{children}</StyledDiv>
  </TooltipContentWrapper>
);
